/**
 * undercover® — "maak 'm van jou": live badge-preview + toevoegen aan de winkelwagen.
 * De preview is de SVG uit snippets/uc-badge-svg.liquid; hier worden alleen data-kleur en de letter gezet.
 */
if (!customElements.get('uc-badge-promo')) {
  const cartReady = () =>
    window.ucCart
      ? Promise.resolve(window.ucCart)
      : new Promise((resolve) => document.addEventListener('uc:cart-ready', () => resolve(window.ucCart), { once: true }));

  class UcBadgePromo extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-badge-variants]')?.textContent || '[]');
      } catch {
        this.variants = [];
      }
      this.form = this.querySelector('[data-badge-form]');
      if (!this.form) return;
      this.svgs = [...this.querySelectorAll('.uc-badge-svg')];
      this.preview = this.querySelector('[data-badge-preview]');
      this.submit = this.querySelector('[data-badge-submit]');
      this.priceEl = this.querySelector('[data-badge-price]');
      this.status = this.querySelector('[data-badge-status]');
      this.live = this.querySelector('[data-badge-live]');
      this.colorName = this.querySelector('[data-badge-color-name]');
      this.letterInputs = [...this.form.querySelectorAll('input[name$="-letter"]')];
      this.colorInputs = [...this.form.querySelectorAll('input[name$="-color"]')];

      this.onChange = (event) => {
        if (event.target.matches('input[name$="-color"]')) this.syncLetters();
        this.update(true);
      };
      this.onSubmit = (event) => {
        event.preventDefault();
        this.add();
      };
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);

      this.syncColors();
      this.syncLetters();
      this.update(false);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit);
    }

    get color() {
      return this.colorInputs.find((i) => i.checked)?.value || this.colorInputs[0]?.value || 'zwart';
    }

    get letter() {
      return this.letterInputs.find((i) => i.checked)?.value || 'A';
    }

    find(color, letter) {
      return this.variants.find((v) => v.color === color && v.letter === letter);
    }

    // Een kleur waarin geen enkele letter meer leverbaar is, wordt uitgeschakeld
    syncColors() {
      this.colorInputs.forEach((input) => {
        input.disabled = !this.variants.some((v) => v.color === input.value && v.available);
      });
      if (this.colorInputs.find((i) => i.checked)?.disabled) {
        const next = this.colorInputs.find((i) => !i.disabled);
        if (next) next.checked = true;
      }
    }

    // Letters die in de gekozen kleur uitverkocht zijn, worden uitgeschakeld
    syncLetters() {
      const color = this.color;
      this.letterInputs.forEach((input) => {
        const variant = this.find(color, input.value);
        input.disabled = !variant || !variant.available;
        input.closest('label')?.classList.toggle('is-soldout', input.disabled);
      });
      const checked = this.letterInputs.find((i) => i.checked);
      if (!checked || checked.disabled) {
        const next = this.letterInputs.find((i) => !i.disabled);
        if (next) next.checked = true;
      }
    }

    update(animate) {
      const color = this.color;
      const letter = this.letter;
      const variant = this.find(color, letter);
      this.svgs.forEach((svg) => {
        svg.dataset.kleur = color;
        const text = svg.querySelector('.uc-badge-svg__letter');
        if (text) text.textContent = letter;
      });
      if (this.colorName) this.colorName.textContent = color;
      if (this.priceEl && variant?.price) this.priceEl.textContent = variant.price;
      if (this.submit) this.submit.disabled = !variant || !variant.available;
      if (this.live) this.live.textContent = `${letter} · ${color}`;
      if (this.status) this.status.textContent = '';
      if (animate && this.preview && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.preview.classList.remove('is-pop');
        void this.preview.offsetWidth;
        this.preview.classList.add('is-pop');
      }
    }

    async add() {
      const variant = this.find(this.color, this.letter);
      if (!variant || !variant.available || this.busy) return;
      this.busy = true;
      this.submit.setAttribute('aria-busy', 'true');
      this.submit.classList.add('is-loading');
      try {
        const cart = await cartReady();
        await cart.add([{ id: variant.id, quantity: 1 }], { source: 'badge-promo', origin: this });
        window.ucTrack?.('badge_addon_added', {
          letter: this.letter,
          color: this.color,
          variant_id: variant.id,
          source: this.dataset.source || 'home',
        });
        this.submit.classList.add('is-done');
        setTimeout(() => this.submit.classList.remove('is-done'), 1800);
      } catch (error) {
        /* ucCart toont zelf een toast */
      } finally {
        this.busy = false;
        this.submit.removeAttribute('aria-busy');
        this.submit.classList.remove('is-loading');
      }
    }
  }

  customElements.define('uc-badge-promo', UcBadgePromo);
}
